import { Button, ModalBody, ModalContent, ModalFooter, ModalHeader, Textarea } from "@heroui/react";
import { zodResolver } from "@hookform/resolvers/zod";
import { useRef } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { useAppApi } from "src/appApi";

const doctorRejectFormSchema = z.object({
	rejectMessageByDoctor: z.string().nonempty({ message: "שדה חובה" }).optional(),
});

type TForm = z.infer<typeof doctorRejectFormSchema>;

export function DoctorRejectRequestModal({ onSubmit }: { onSubmit: (form: TForm) => void | Promise<void> }) {
	const appApi = useAppApi();
	const {
		handleSubmit,
		register,
		formState: { errors, isSubmitting },
	} = useForm<TForm>({
		resolver: zodResolver(doctorRejectFormSchema),
	});

	// One rejection per dialog (see DoctorApproveRequestModal).
	const submitted = useRef(false);
	const _onSubmit = handleSubmit(async (data) => {
		if (submitted.current) return;
		submitted.current = true;
		try {
			await onSubmit(data);
		} catch (error) {
			submitted.current = false;
			throw error;
		}
	}, (errors) => {
		console.error(errors);
		appApi.api.system.uiLogs({
			message: "DoctorRejectRequestModal form validation error",
			severity: "ERROR",
			errors,
		});
	});

	const ref = useRef<HTMLFormElement>(null);

	return (
		<ModalContent>
			{(onClose) => (
				<>
					<ModalHeader>דחיית בקשה</ModalHeader>
					<ModalBody className="py-0">
						<form onSubmit={_onSubmit} ref={ref}>
							<Textarea
								{...register("rejectMessageByDoctor")}
								label="סיבת דחיה"
								isInvalid={!!errors?.rejectMessageByDoctor?.message}
								errorMessage={errors?.rejectMessageByDoctor?.message}
							/>
							<ModalFooter className="px-0">
								<Button variant="light" onPress={onClose}>
									ביטול
								</Button>
								<Button type="submit" color="danger" isLoading={isSubmitting}>
									דחה
								</Button>
							</ModalFooter>
						</form>
					</ModalBody>
				</>
			)}
		</ModalContent>
	);
}
